//Global Imports
import React from "react";
import moment from "moment";
//End Global Imports

//Local Imports
import { IForgotPassword } from "./ForgotPassword";
import { forgotPassword, getRequestTime, sendOtp, validateOtp } from "../../../services/auth";
import StepThree from "./StepThree";
import StepOne from "./StepOne";
import OtpPhase from "../OtpPhase";
import ForgotPasswordModal from "../../../components/ui/ForgotPasswordModal";
import { ForgotPasswordSuccessBanner } from "../../../assets/Icons";
import Modal from "../../../components/ui/Modal";
import Button from "../../../components/ui/Button";
import AuthBgLayout from "../../../components/layout/AuthBgLayout";
import StepOneNew from "./StepOneNew";
import OtpPhaseNew from "../OtpPhase/OtpPhaseNew";
import StepThreeNew from "./StepThreeNew";
import { SuccessfullBanner } from "../SignUp/SuccessfullBanner";
import { useNavigate } from "react-router-dom";
//End Local Imports

const ForgotPasswordNew: React.FC<IForgotPassword.IProps> = ({
  setIsForgotPassword,
}) => {
  const [email, saveEmail] = React.useState<string>("");
  const [step, setStep] = React.useState<number>(1);
  const [otpValue, setOtpValue] = React.useState<string>("");
  const [otpError, setOTPError] = React.useState<boolean>(false);
  const [isOTPVerified, setOTPVerified] = React.useState<boolean>(false);
  const [verifyOtpError, setVerifyOtpError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now() + 120000);
  const [dateKey, saveDateKey] = React.useState<number>(0);
  const [error, setError] = React.useState<string>("");

  const navigate = useNavigate();

  const goBackHandler = () => {
    setStep(1);
    setOtpValue("");
    setOTPError(false);
    setOTPVerified(false);
    setVerifyOtpError("");
    saveDateKey(0);
    setError("");
    setIsForgotPassword(false);
  };

  const registerEmail = (data: any) => {
    saveEmail(data.email);

    sendOtp({
      body: { email: data.email, otpType: "email" },
      apiType: "send",
    })
      .then(() => {
        setStep(2);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const verifyOTP = () => {
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      validateOtp({
        email_phone: email,
        otp: otpValue,
        otpType: "email",
      })
        .then((response: any) => {
          const responseTime = response?.data?.timeStamp;
          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            setOTPError(false);
            setOTPVerified(true);
            setTimeout(() => {
              setVerifyOtpError("");
              setOTPVerified(false);
              setStep(3);
            }, 1000);
          } else if (response?.data?.is_invalid) {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.data?.message);
          } else {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          setOTPError(true);
          setOTPVerified(false);
          setVerifyOtpError(error?.response?.data?.error?.type);
        });
    });
  };

  const resendOTP = () => {
    sendOtp({
      body: {
        email: email,
        otpType: "email",
      },
      apiType: "resend",
    })
      .then(() => {
        setOtpValue("");
        saveDate(Date.now() + 120000);
        saveDateKey(dateKey + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const saveNewPassword = (data: any) => {
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      forgotPassword({
        email: email,
        otp: otpValue,
        newPassword: data.password,
        confirmPassword: data.confirmPassword,
      })
        .then((response) => {
          const responseTime = response?.data?.timeStamp;

          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            setStep(4);
            // setIsForgotPassword(false);
          } else {
            setError(response?.data?.message);
          }
        })
        .catch((error) => {
          setError(error.response.data.error.type);
          setTimeout(() => {
            setStep(1);
            setError("");
          }, 2000);
        });
    });
  };

  return (
    <>
      <AuthBgLayout>
        {step === 1 && (
          <div className={"flex flex-col items-start justify-center py-4"}>
            <StepOneNew registerEmail={registerEmail} />
          </div>
        )}
        {step === 2 && (
          <div className={"flex  justify-center w-full py-4"}>
            <OtpPhaseNew
              title={
                <div className="flex flex-col items-start gap-3 mb-6">
                  <p className="xl:text-[28px] lg:text-[20px] font-semibold text-[#000]">Forgot Password?</p>
                  <p className="xl:text-[20px] lg:text-[14px] font-normal text-[#000]">Please enter the OTP sent to your email to reset your password</p>
                </div>
              }
              otpValue={otpValue && otpValue}
              setOtpValue={setOtpValue}
              otpError={otpError && otpError}
              verifyOTP={verifyOTP}
              email={email && email}
              isOTPVerified={isOTPVerified && isOTPVerified}
              verifyOtpError={verifyOtpError && verifyOtpError}
              resendOTP={resendOTP}
              dateKey={dateKey && dateKey}
              date={date && date}
              buttonText="Verify"
            />
          </div>
        )}
        {step === 3 && (
          <div className="w-full">
            <StepThreeNew saveNewPassword={saveNewPassword} email={email} />
          </div>
        )}

        {step === 4 && (
          <SuccessfullBanner btnText="Continue to log in" title="All set — your password’s been updated." handler={() => {
            setIsForgotPassword(false);
            navigate("/auth/sign-in-new")
          }}
          />
        )}

        {error !== "" && <div className="mt-4 text-sm text-error">{error}</div>}
        {step === 4 ? null :
          <p
            className="text-[#0F5BF1] font-inter xl:text-base lg:text-sm font-normal cursor-pointer text-center"
            onClick={() => {
              goBackHandler();
            }}
          >
            Go Back to Login
          </p>
        }
      </AuthBgLayout>
    </>
  );
};

export default ForgotPasswordNew;
